export const MARK_WORDS = {
	1: 'negatīvs vērtējums',
	2: 'negatīvs vērtējums',
	3: 'negatīvs vērtējums',
	4: 'gandrīz viduvēji',
	5: 'viduvēji',
	6: 'gandrīz labi',
	7: 'labi',
	8: 'ļoti labi',
	9: 'teicami',
	10: 'izcili'
};

export const RTV = {
	kas: 'Rīgas Tālmācibas vidusskola',
	kur: 'Rīgas Tālmācības vidusskolā',
	ko: 'Rīgas Tālmācības vidusskolu',
};

export const PROGRAM = {
	kas: 'Vispārējā pamatizglītība',
	ko: 'Vispārējo pamatizglītību',
	ko2: 'pamatizglītības 2. posma (7.-9.klase) programmu'
};

export const centimetersToPoints = (cm) => {
	return cm / 2.54 * 72;
};